(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('CommunicationParameterDeleteController',CommunicationParameterDeleteController);

    CommunicationParameterDeleteController.$inject = ['$uibModalInstance', 'entity', 'CommunicationParameter'];

    function CommunicationParameterDeleteController($uibModalInstance, entity, CommunicationParameter) {
        var vm = this;

        vm.communicationParameter = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CommunicationParameter.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
